import React, { FC, useState } from 'react';

import classNames from 'classnames';

import { IconProps } from '../../shared/ui';

export const TgIcon: FC<IconProps> = ({ width = 40, height = 40, fillBg = '#C00000', className, needHover = true }) => {
  const [hover, setHover] = useState(false);
  return (
    <svg
      onMouseMove={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={classNames(className, { 'cursor-pointer': needHover })}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="10" fill={hover && needHover ? '#111026' : fillBg} />
      <g clipPath="url(#clip0_371_3144)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.4789 13.6916C26.6848 13.605 26.9103 13.5751 27.1317 13.6051C27.3531 13.6351 27.5624 13.7239 27.7378 13.8622C27.9133 14.0006 28.0484 14.1834 28.1292 14.3917C28.21 14.6 28.2335 14.8262 28.1973 15.0466L26.3073 26.5108C26.1239 27.6166 24.9106 28.2508 23.8964 27.7C23.0481 27.2391 21.7881 26.5291 20.6548 25.7883C20.0881 25.4175 18.3523 24.23 18.5656 23.385C18.7489 22.6625 21.6656 19.9475 23.3323 18.3333C23.9864 17.6991 23.6881 17.3333 22.9156 17.9166C20.9973 19.365 17.9173 21.5675 16.8989 22.1875C16.0006 22.7341 15.5323 22.8275 14.9723 22.7341C13.9506 22.5641 13.0031 22.3008 12.2298 21.98C11.1848 21.5466 11.2356 20.11 12.2289 19.6916L26.4789 13.6916Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_371_3144">
          <rect width="20" height="20" fill="white" transform="translate(10 10)" />
        </clipPath>
      </defs>
    </svg>
  );
};
